import React, { useState } from "react";
import { Container, Row } from "reactstrap";

// Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import SubscriptionsPage from "./subscription";

const Subscriptions = () => {
  const [breadcrumbItems] = useState([
    { title: "Minimis", link: "/" },
    { title: "Subscriptions", link: "#" },
  ]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="" breadcrumbItems={breadcrumbItems} />
          <Row>
            <SubscriptionsPage />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Subscriptions;
